import React from "react";
import { useErrorContext } from "../contexts/ErrorContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faExclamationTriangle,
    faTimes,
} from "@fortawesome/pro-solid-svg-icons";

const GlobalErrorDisplay: React.FC = () => {
    const { errors, removeError } = useErrorContext();

    if (errors.length === 0) {
        return null;
    }

    return (
        <div
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
            className="flex bg-black/50 backdrop-blur-md overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-99 justify-center w-full md:inset-0 h-full"
        >
            <div className="flex flex-col space-y-4 p-4 max-w-2xl w-full mx-auto max-h-full justify-center items-center overflow-y-scroll">
                {errors.map((error) => (
                    <div
                        key={error.id}
                        className={`relative flex flex-col w-full max-h-96 bg-white rounded-lg shadow-xs
                        ${
                            error.type === "relay"
                                ? "border-l-4 border-red-500"
                                : ""
                        }
                        ${
                            error.type === "network"
                                ? "border-l-4 border-orange-500"
                                : ""
                        }
                        ${
                            error.type === "validation"
                                ? "border-l-4 border-yellow-500"
                                : ""
                        }
                        ${
                            error.type === "general"
                                ? "border-l-4 border-gray-500"
                                : ""
                        }
                    `}
                    >
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t border-gray-200">
                            <div className="shrink-0">
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className="h-5 w-5 text-red-400"
                                />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 ">
                                {error.type === "relay" && "GraphQL Error"}
                                {error.type === "network" && "Network Error"}
                                {error.type === "validation" &&
                                    "Validation Error"}
                                {error.type === "general" && "Error"}
                            </h3>
                            <button
                                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={() => removeError(error.id)}
                            >
                                <span className="sr-only">Close</span>
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="h-5 w-5"
                                />
                            </button>
                        </div>
                        <div className="p-4 md:p-5 space-y-4 overflow-y-scroll">
                            <div className="flex items-start">
                                <div className="ml-3 w-0 flex-1">
                                    <p className="mt-1 text-sm text-gray-500">
                                        {error.message}
                                    </p>
                                    {error.details && (
                                        <details className="mt-2">
                                            <summary className="text-xs text-gray-400 cursor-pointer">
                                                Show details
                                            </summary>
                                            <pre className="mt-1 text-xs text-gray-400 overflow-auto">
                                                {JSON.stringify(
                                                    error.details,
                                                    null,
                                                    2
                                                )}
                                            </pre>
                                        </details>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GlobalErrorDisplay;
